<template>
    <left-stripe-layout
        class="d-flex flex-column justify-center" 
        :class="hasImage ? 'hasImage' : ''"
        :color="announcement.color"
    >
        <Header 
            class="header"
            :large="isLandscape && !isParallel" 
            :color="announcement.color"
            :icon="!hasImage ? announcement.iconName : null"
            :text="displayShort && announcement.shortTitle ? announcement.shortTitle : announcement.title"
        ></Header>
        <div
            v-if="hasImage"
            :class="'image ' + (isLandscape ? '' : 'order-first')"
            :style="{'background-image': imageUrl}" 
        ></div>
        <p
            v-html="displayShort && announcement.shortText ? announcement.shortText : announcement.text" 
            class="announcement-text flex-grow-1"
        ></p>
        <div v-if="announcement.url" class="announcement-url d-flex align-center">
            <div class="announcement-url-text">{{urlWithoutPrefix}}</div>
        </div>
        <qrcode v-if="announcement.url" class="announcement-url-qr" :value="announcement.url" :options="{ width: 250, margin: 2 }"></qrcode>
    </left-stripe-layout>
</template>

<script>
import {config} from '@/config';
import Header from "../../../components/Header";
import LeftStripeLayout from './Layouts/LeftStripeLayout.vue';

export default {
    name: "BasicView",

    components: {
        Header,
        LeftStripeLayout,
    },

    props: {
        announcement: Object,
        isLandscape: Boolean,
        isParallel: Boolean,
        isPreview: Boolean
    },

    data() {
        return {
        }
    },

    computed: {
        serverUrl() {
            return config.serverUrl;
        },

        imageUrl() {
            const imageUrl = this.announcement.announcementImage 
                ? `url('${this.serverUrl}displays/images/${this.announcement.id}/${this.announcement.announcementImage.id}')`
                : undefined;
            return this.isPreview 
                ? (this.announcement.imageUrl && `url('${this.announcement.imageUrl}')` || imageUrl)
                : imageUrl;
        },
        
        displayShort() {
            return this.isParallel && this.isLandscape || this.hasImage;
        },

        hasImage() {
            return Boolean(this.announcement.announcementImage || this.announcement.imageUrl);
        },

        urlWithoutPrefix() {
            return this.announcement.url.replace(/^https?:\/\//gi, "").replace(/\/$/gi, "");
        },
    },
}
</script>

<style scoped>
    .announcement.landscape.hasImage {
        padding-left: 45%;
    }

    .header {
        margin-top: 4%;
        margin-bottom: 3%;
    }


    /* TEXT CONTENT */

    .announcement-text {
        font-size: 3vw;
        margin-bottom: 0;
    }

    .parallel .announcement-text
    {
        font-size: 1.6vw;
    }

    .announcement-text >>> p {
        margin-bottom: 0;
    }


    /* IMAGE */

    .image {
        background-position: 50% 50%;
        background-size: cover;
        background-repeat: no-repeat;
        border-radius: 50%;
        vertical-align: middle;
    }

    .portrait .image {
        margin-top: 2vh;
        height: 25vw;
        width: 25vw;
        align-self: center;
    }
    
    .landscape .image {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: -25%;
        height: 65vw;
        width: 65vw;
    }

    .parallel.landscape .image {
        height: 130%;
        width: 66%;
    }


    /* LINK */

    .announcement-url {
        height: 4vw;
        margin-bottom: 0;
        margin-right: 5vw;
    }

    .single .announcement-url {
        height: 6vw;
    }

    .announcement-url-text {
        width: 100%;
        color: var(--base-color);
        font-weight: 500;
        font-size: 2vw;
        overflow-wrap: break-word;
        line-height: 1.1;
    }

    .parallel .announcement-url-text,
    .portrait .announcement-url-text
    {
        font-size: 1.4vw; /* smaller font size for displaying in parallel */
    }

    .announcement-url-qr {
        max-height: 4vw;
        max-width: 4vw;
        object-fit: contain;
        filter: invert(100%);
        overflow: hidden;
        position: absolute;
        right: 2vw;
        bottom: 1vw;
    }

    .single .announcement-url-qr {
        max-height: 7vw;
        max-width: 7vw;
    }

</style>
